module.exports = __webpack_public_path__ + "img/20200514_151058.be6791a6.jpg";